import { Component } from '@angular/core';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { PATHS } from '@shared/constants/paths';

@Component({
  selector: 'app-product-detail-not-found',
  templateUrl: './product-detail-not-found.component.html',
  styleUrls: ['./product-detail-not-found.component.scss'],
})
export class ProductDetailNotFoundComponent {
  constructor(readonly navigationHelperService: NavigationHelperService) {}

  goToHome() {
    this.navigationHelperService.routeTo(PATHS.HOME);
  }
}
